<template>
	<div class="prison-solution-page">
		<Head />
		<main class="prison-main">
			<section class="hero-section section-padding">
				<div class="container-custom hero-grid">
					<div class="fade-in">
						<div class="hero-badge">监管行业心理矫治解决方案</div>
						<h1>看守所/监狱心理测评<br>与心理矫治管理系统</h1>
						<p>
							遵循《监狱法》《监狱教育改造工作规定》，构建<span>测评-预警-干预-跟踪-销号</span>全流程闭环管理，实现监管场所心理工作科学化、规范化、信息化。
						</p>
						<div class="hero-actions">
							<a href="#contact" class="btn-primary">获取完整实施方案</a>
							<a href="#function" class="btn-outline">查看核心功能</a>
						</div>
						<div class="hero-points">
							<div><i class="el-icon-success"></i>72小时全覆盖筛查</div>
							<div><i class="el-icon-success"></i>等保三级及以上</div>
							<div><i class="el-icon-success"></i>一人一档终身追溯</div>
						</div>
					</div>
					<div class="hero-image-wrap fade-in">
						<img src="https://picsum.photos/1000/620?random=30" alt="监管心理矫治系统指挥大屏">
					</div>
				</div>
			</section>

			<section id="overview" class="section-padding">
				<div class="container-custom">
					<div class="section-head">
						<h2>项目概述</h2>
						<div class="title-underline"></div>
						<p>背景、目标、原则三位一体，锚定监管场所心理矫治工作核心需求。</p>
					</div>
					<div class="three-grid">
						<div class="card card-effect">
							<div class="icon-wrap"><i class="el-icon-document"></i></div>
							<h3>项目背景</h3>
							<ul>
								<li v-for="item in projectBackgroundList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="card card-effect">
							<div class="icon-wrap"><i class="el-icon-aim"></i></div>
							<h3>建设目标</h3>
							<ul>
								<li v-for="item in buildTargetList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="card card-effect">
							<div class="icon-wrap"><i class="el-icon-s-check"></i></div>
							<h3>建设原则</h3>
							<div class="principle-grid">
								<div v-for="item in buildPrincipleList" :key="item">{{ item }}</div>
							</div>
							<p class="tip-text">严格遵循监管行业标准，贴合一线工作，支持多级部署与系统对接。</p>
						</div>
					</div>
				</div>
			</section>

			<section id="design" class="section-padding section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>总体设计</h2>
						<div class="title-underline"></div>
						<p>四层系统架构 + 全链路安全体系，保障系统稳定、安全、高效运行。</p>
					</div>
					<div class="two-grid">
						<div class="card card-effect">
							<h3 class="gradient-text">四级系统架构</h3>
							<div class="stack-list">
								<div v-for="item in architectureList" :key="item.title" class="stack-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-effect">
							<h3 class="gradient-text">全链路安全体系</h3>
							<ul class="feature-list">
								<li v-for="item in securityRequirementList" :key="item.title">
									<div class="feature-icon"><i :class="item.icon"></i></div>
									<div>
										<h4>{{ item.title }}</h4>
										<p>{{ item.desc }}</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="function" class="section-padding">
				<div class="container-custom">
					<div class="section-head">
						<h2>十大核心功能模块</h2>
						<div class="title-underline"></div>
						<p>全维度覆盖监管心理矫治工作，贴合一线业务，提升效率与专业性。</p>
					</div>
					<div class="module-grid">
						<div v-for="item in coreModuleList" :key="item.title" class="module-card card-effect">
							<div class="module-head">
								<div class="module-icon"><i :class="item.icon"></i></div>
								<h4>{{ item.title }}</h4>
							</div>
							<ul>
								<li v-for="point in item.points" :key="point">{{ point }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="workflow" class="section-padding section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>四大标准化业务流程</h2>
						<div class="title-underline"></div>
						<p>标准化、流程化、留痕化，让监管心理工作有章可循、有据可查。</p>
					</div>
					<div class="workflow-grid">
						<div v-for="item in workflowList" :key="item.title" class="workflow-card card-effect">
							<div class="workflow-icon"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<div class="steps">
								<div v-for="(step, index) in item.steps" :key="step" class="step-item">
									<span>{{ index + 1 }}</span>
									<p>{{ step }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="support" class="section-padding">
				<div class="container-custom">
					<div class="section-head">
						<h2>硬件部署 · 实施保障 · 建设意义</h2>
						<div class="title-underline"></div>
						<p>全流程保障项目落地，让系统真正服务监管工作并创造实际价值。</p>
					</div>
					<div class="three-grid">
						<div class="card card-effect">
							<h3 class="gradient-text">硬件部署建议</h3>
							<ul class="dot-list">
								<li v-for="item in hardwareList" :key="item.title">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</li>
							</ul>
						</div>
						<div class="card card-effect">
							<h3 class="gradient-text">实施与服务保障</h3>
							<div class="box-list">
								<div v-for="item in supportList" :key="item.title" class="box-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-effect">
							<h3 class="gradient-text">项目建设意义</h3>
							<ul class="value-list">
								<li v-for="item in projectValueList" :key="item.title">
									<i class="el-icon-success"></i>
									<div>
										<strong>{{ item.title }}</strong>
										<span>{{ item.desc }}</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section class="summary-section">
				<div class="container-custom summary-box">
					<h2>方案总结</h2>
					<p>
						本系统集心理测评、风险预警、档案管理、矫治干预、统计分析、数据对接于一体，严格遵循监管行业规范与保密要求，通过数字化手段实现对在押人员全周期、全覆盖、全闭环心理管理。
					</p>
					<!-- <a href="#contact" class="summary-btn">立即咨询，获取定制化解决方案</a> -->
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue'
	import SiteFooter from '@/components/footer/index.vue'

	export default {
		name: 'PrisonSolution',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				projectBackgroundList: [
					'贯彻《监狱法》等法规对心理矫治的明确要求',
					'识别防范自杀、暴力、脱逃等各类安全风险',
					'提升教育改造工作科学化、规范化、信息化水平'
				],
				buildTargetList: [
					'72小时全覆盖心理初筛，早发现早预警',
					'一人一档，建立终身电子心理档案',
					'构建全流程闭环管理，处置所有风险点',
					'推动数据互联互通，打破信息孤岛'
				],
				buildPrincipleList: ['合规性', '安全性', '实用性', '专业性', '扩展性'],
				architectureList: [{
						title: '展示层',
						desc: 'PC端、平板端、心理测评自助一体机、指挥中心大屏可视化'
					},
					{
						title: '应用层',
						desc: '民警端、心理矫治师端、管理员端、自助测评端'
					},
					{
						title: '服务层',
						desc: '测评引擎、预警引擎、报表引擎、对外接口服务'
					},
					{
						title: '数据层',
						desc: '人员基础库、心理测评库、预警信息库、电子档案库、系统日志库'
					}
				],
				securityRequirementList: [{
						title: '物理隔离部署',
						desc: '部署于监管内网/政务专网，与互联网物理隔离，从网络层面保障安全。',
						icon: 'el-icon-lock'
					},
					{
						title: '支持离线测评',
						desc: '离线模式完成测评，联网后数据自动同步，适应复杂网络环境。',
						icon: 'el-icon-connection'
					},
					{
						title: '全程数据安全',
						desc: '存储传输加密、展示脱敏、日志全记录，满足等保三级及以上标准。',
						icon: 'el-icon-s-check'
					}
				],
				coreModuleList: [{
						title: '人员信息管理',
						icon: 'el-icon-user',
						points: ['对接监管系统，自动同步人员基本信息', '支持手动/批量导入，多类别分类管理', '自动更新入所、羁押、出所等状态']
					},
					{
						title: '权限与角色管理',
						icon: 'el-icon-lock',
						points: ['管理员/矫治民警/管教民警三级权限', '细粒度控制查看、测评、编辑等操作', '核心环节多人审核，确保数据不可篡改']
					},
					{
						title: '测评任务管理',
						icon: 'el-icon-s-order',
						points: ['定时/批量/单人测评、复测管控多模式', '摄像头核验与答题校验，全方位防作弊', '实时监控测评进度，可视化精细化管理']
					},
					{
						title: '专业量表库',
						icon: 'el-icon-reading',
						points: ['基础筛查：SCL-90、SDS、SAS 等量表', '监管专用量表覆盖重点风险场景', '特殊人群专属量表按需使用']
					},
					{
						title: '报告与档案管理',
						icon: 'el-icon-document',
						points: ['自动生成个人/团体分析报告', '支持在线查看、导出、打印', '一人一档整合测评与干预全数据']
					},
					{
						title: '风险预警与研判',
						icon: 'el-icon-warning',
						points: ['红/黄/蓝分级预警机制', '弹窗、消息、定向推送秒级响应', '预警到销号全流程闭环处置']
					},
					{
						title: '心理矫治与干预',
						icon: 'el-icon-chat-line-round',
						points: ['支持个别教育、团体辅导、危机疏导', '接诊-评估-方案-实施-回访标准化', '重点人员包保责任制协同联动']
					},
					{
						title: '统计分析与可视化',
						icon: 'el-icon-data-analysis',
						points: ['多维分析心理状态、风险分布、完成率', '图表/报表可视化，支持大屏展示', '为管理决策提供科学数据支撑']
					},
					{
						title: '出所/出监心理评估',
						icon: 'el-icon-s-release',
						points: ['自动整合全周期数据生成评估报告', '支撑安置帮教与社区矫正衔接', '档案按规封存并长期可追溯']
					},
					{
						title: '系统管理与安全审计',
						icon: 'el-icon-setting',
						points: ['账号管理、密码策略、异常登录告警', '操作/修改/导出日志全程记录', '自动定时备份与一键恢复']
					}
				],
				workflowList: [{
						title: '入所心理初筛',
						icon: 'el-icon-s-promotion',
						steps: ['收押登记', '72小时内心理测评', '自动生成风险等级', '建立心理档案', '重点人员标记']
					},
					{
						title: '日常动态监测',
						icon: 'el-icon-refresh',
						steps: ['批量派测与完成', '系统自动研判', '预警人员推送', '谈话干预与记录']
					},
					{
						title: '风险预警处置',
						icon: 'el-icon-bell',
						steps: ['系统预警与签收', '现场核查与评估', '分级干预与跟踪', '风险销号闭环']
					},
					{
						title: '出所评估流程',
						icon: 'el-icon-document',
						steps: ['到期前综合测评', '心理状态风险再评估', '出具正式评估报告', '档案归档与移交']
					}
				],
				hardwareList: [{
						title: '测评终端',
						desc: '专用电脑/平板，满足民警操作与集中测评。'
					},
					{
						title: '网络与服务器',
						desc: '高性能内网交换机和服务器，安全稳定存储数据。'
					},
					{
						title: '自助测评设备',
						desc: '心理测评自助一体机，提升自主测评效率。'
					},
					{
						title: '辅助设备',
						desc: '身份核验摄像头与报告打印机，完善业务闭环。'
					}
				],
				supportList: [{
						title: '科学实施周期',
						desc: '需求调研→部署配置→调试试运行→验收交付（18-20个工作日）'
					},
					{
						title: '全面培训体系',
						desc: '操作培训、报告解读、危机处置、量表应用全覆盖。'
					},
					{
						title: '可靠售后服务',
						desc: '7x12小时技术支持、维护巡检、量表与功能持续迭代。'
					}
				],
				projectValueList: [{
						title: '安全层面：',
						desc: '提前识别高风险人员，预防安全事件。'
					},
					{
						title: '改造层面：',
						desc: '科学矫治，提升教育改造质量。'
					},
					{
						title: '管理层面：',
						desc: '工作标准化、流程化，便于检查考核。'
					},
					{
						title: '执法层面：',
						desc: '形成完整台账和证据链，规范执法行为。'
					}
				],
				contactPersons: [{
						name: '张先生',
						phone: '13161072501'
					},
					{
						name: '许女士',
						phone: '15031192537'
					},
					{
						name: '安先生',
						phone: '18932907651'
					}
				],
				consultationForm: {
					name: '',
					phone: '',
					org: '',
					demand: '',
					desc: ''
				}
			}
		},
		mounted() {
			this.scrollToHashTarget()
		},
		watch: {
			'$route.hash'() {
				this.scrollToHashTarget()
			}
		},
		methods: {
			scrollToHashTarget() {
				if (!this.$route.hash) {
					return
				}
				this.$nextTick(() => {
					const target = document.querySelector(this.$route.hash)
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						})
					}
				})
			},
			handleConsultSubmit() {
				window.alert('咨询信息提交成功！我们将在1个工作日内与您联系。')
				this.consultationForm = {
					name: '',
					phone: '',
					org: '',
					demand: '',
					desc: ''
				}
			}
		}
	}
</script>

<style scoped>
	.prison-solution-page {
		background: #f8fafc;
		color: #1a202c;
		min-height: 100vh;
	}

	.prison-main {
		padding-top: 64px;
	}

	.container-custom {
		max-width: 1260px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section-padding {
		padding: 64px 0;
	}

	.section-soft {
		background: #f3f7fb;
	}

	.section-head {
		max-width: 780px;
		margin: 0 auto 38px;
		text-align: center;
	}

	.section-head h2 {
		margin: 0;
		font-size: clamp(30px, 4vw, 46px);
		line-height: 1.3;
	}

	.section-head p {
		margin: 0;
		font-size: 17px;
		line-height: 1.75;
		color: #5c6878;
	}

	.title-underline {
		width: 68px;
		height: 5px;
		margin: 18px auto;
		border-radius: 999px;
		background: linear-gradient(90deg, #0f4c81, #4fc3f7);
	}

	.hero-section {
		background: linear-gradient(135deg, rgba(15, 76, 129, 0.07) 0%, rgba(15, 76, 129, 0.12) 100%);
	}

	.hero-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 30px;
		align-items: center;
	}

	.hero-badge {
		display: inline-block;
		padding: 7px 14px;
		margin-bottom: 10px;
		font-size: 13px;
		color: #0f4c81;
		background: rgba(15, 76, 129, 0.12);
		border-radius: 999px;
	}

	.hero-section h1 {
		margin: 0 0 14px;
		font-size: clamp(34px, 5vw, 62px);
		line-height: 1.25;
	}

	.hero-section p {
		margin: 0;
		font-size: 18px;
		line-height: 1.75;
		color: #4b5563;
	}

	.hero-section p span {
		font-weight: 700;
		color: #0f4c81;
	}

	.hero-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin: 24px 0 16px;
	}

	.btn-primary,
	.btn-outline {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 12px 24px;
		border-radius: 10px;
		font-size: 15px;
		font-weight: 600;
		text-decoration: none;
		border: 1px solid transparent;
		cursor: pointer;
	}

	.btn-primary {
		background: #0f4c81;
		color: #fff;
		border-color: #0f4c81;
	}

	.btn-primary:hover {
		background: #0c3f6c;
	}

	.btn-primary.full {
		width: 100%;
	}

	.btn-outline {
		color: #0f4c81;
		border-color: #0f4c81;
		background: transparent;
	}

	.btn-outline:hover {
		background: rgba(15, 76, 129, 0.06);
	}

	.hero-points {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 8px;
	}

	.hero-points div {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		color: #4b5563;
	}

	.hero-points i {
		color: #0f4c81;
	}

	.hero-image-wrap {
		border: 1px solid #dbe5f0;
		border-radius: 18px;
		padding: 10px;
		background: #fff;
		box-shadow: 0 12px 28px rgba(15, 76, 129, 0.14);
	}

	.hero-image-wrap img {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 12px;
	}

	.card {
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 16px;
		padding: 24px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	}

	.card-effect {
		transition: all 0.35s ease;
	}

	.card-effect:hover {
		transform: translateY(-6px);
		box-shadow: 0 12px 28px rgba(15, 76, 129, 0.15);
	}

	.three-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 18px;
	}

	.two-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 18px;
	}

	.icon-wrap {
		width: 54px;
		height: 54px;
		border-radius: 12px;
		background: rgba(15, 76, 129, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 14px;
	}

	.icon-wrap i {
		font-size: 28px;
		color: #0f4c81;
	}

	.card h3 {
		margin: 0 0 14px;
		font-size: 24px;
	}

	.card ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.card ul li {
		position: relative;
		padding-left: 16px;
		margin-bottom: 8px;
		font-size: 15px;
		line-height: 1.7;
		color: #4b5563;
	}

	.card ul li::before {
		content: '';
		position: absolute;
		left: 0;
		top: 10px;
		width: 7px;
		height: 7px;
		border-radius: 999px;
		background: #0f4c81;
	}

	.principle-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 8px;
	}

	.principle-grid div {
		padding: 8px 10px;
		font-size: 14px;
		color: #4b5563;
		background: #f6f9fc;
		border: 1px solid #e3edf7;
		border-radius: 8px;
	}

	.tip-text {
		margin: 10px 0 0;
		font-size: 13px;
		color: #6b7280;
		line-height: 1.6;
	}

	.gradient-text {
		background: linear-gradient(90deg, #0f4c81, #4fc3f7);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		color: transparent;
	}

	.stack-list {
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.stack-item {
		border-left: 4px solid #0f4c81;
		padding-left: 12px;
	}

	.stack-item h4,
	.feature-list h4,
	.dot-list h4,
	.box-item h4 {
		margin: 0;
		font-size: 18px;
	}

	.stack-item p,
	.feature-list p,
	.dot-list p,
	.box-item p {
		margin: 4px 0 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5d697a;
	}

	.feature-list {
		margin: 0;
		padding: 0;
		list-style: none;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.feature-list li {
		display: flex;
		gap: 10px;
		align-items: flex-start;
	}

	.feature-icon {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: rgba(15, 76, 129, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.feature-icon i {
		color: #0f4c81;
	}

	.module-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.module-card {
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		padding: 18px 16px;
	}

	.module-head {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 10px;
	}

	.module-icon {
		width: 38px;
		height: 38px;
		border-radius: 10px;
		background: rgba(15, 76, 129, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.module-icon i {
		color: #0f4c81;
	}

	.module-head h4 {
		margin: 0;
		font-size: 18px;
	}

	.module-card ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.module-card li {
		position: relative;
		padding-left: 12px;
		margin-bottom: 6px;
		font-size: 14px;
		line-height: 1.65;
		color: #5d697a;
	}

	.module-card li::before {
		content: '•';
		position: absolute;
		left: 0;
		color: #0f4c81;
	}

	.workflow-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 14px;
	}

	.workflow-card {
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		padding: 18px 14px;
		text-align: center;
	}

	.workflow-icon {
		width: 52px;
		height: 52px;
		border-radius: 50%;
		background: rgba(15, 76, 129, 0.1);
		margin: 0 auto 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.workflow-icon i {
		font-size: 24px;
		color: #0f4c81;
	}

	.workflow-card h3 {
		margin: 0 0 12px;
		font-size: 18px;
	}

	.steps {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.step-item {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 7px 8px;
		background: #f6f9fc;
		border-radius: 8px;
	}

	.step-item span {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: #0f4c81;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
	}

	.step-item p {
		margin: 0;
		font-size: 13px;
		color: #4b5563;
	}

	.dot-list,
	.value-list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.dot-list li {
		margin-bottom: 10px;
		padding-left: 14px;
		position: relative;
	}

	.dot-list li::before {
		content: '';
		position: absolute;
		left: 0;
		top: 8px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #0f4c81;
	}

	.box-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.box-item {
		background: #f6f9fc;
		padding: 12px;
		border-radius: 10px;
		border: 1px solid #e2edf8;
	}

	.value-list li {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		margin-bottom: 10px;
	}

	.value-list i {
		color: #0f4c81;
		margin-top: 4px;
	}

	.value-list strong,
	.value-list span {
		display: inline;
		font-size: 14px;
		line-height: 1.7;
		color: #4b5563;
	}

	.summary-section {
		padding: 58px 0;
		background: linear-gradient(90deg, #0f4c81 0%, #3876bf 100%);
	}

	.summary-box {
		max-width: 900px;
		text-align: center;
	}

	.summary-box h2 {
		margin: 0 0 14px;
		color: #fff;
		font-size: 34px;
	}

	.summary-box p {
		margin: 0;
		color: rgba(255, 255, 255, 0.92);
		font-size: 18px;
		line-height: 1.8;
	}

	.summary-btn {
		display: inline-flex;
		margin-top: 20px;
		padding: 12px 24px;
		border-radius: 10px;
		background: #fff;
		color: #0f4c81;
		font-weight: 700;
		text-decoration: none;
	}

	.summary-btn:hover {
		background: #f5f7fa;
	}

	.contact-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 18px;
	}

	.contact-form {
		background: #f8fafc;
		border: 1px solid #deebf8;
		border-radius: 14px;
		padding: 22px;
	}

	.form-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}

	.form-item {
		margin-bottom: 12px;
	}

	.form-item label {
		display: block;
		margin-bottom: 6px;
		font-size: 14px;
		color: #374151;
	}

	.form-item input,
	.form-item select,
	.form-item textarea {
		width: 100%;
		box-sizing: border-box;
		padding: 10px 12px;
		font-size: 14px;
		border: 1px solid #d5dee9;
		border-radius: 8px;
		outline: none;
	}

	.form-item input:focus,
	.form-item select:focus,
	.form-item textarea:focus {
		border-color: #3876bf;
		box-shadow: 0 0 0 3px rgba(56, 118, 191, 0.16);
	}

	.contact-aside {
		border-radius: 14px;
		padding: 24px 20px;
		color: #fff;
		background: linear-gradient(135deg, #0f4c81 0%, #3876bf 100%);
	}

	.contact-aside h3 {
		margin: 0 0 18px;
		font-size: 30px;
	}

	.person-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.person-item {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.person-icon {
		width: 42px;
		height: 42px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.person-name {
		margin: 0 0 2px;
		font-size: 13px;
		opacity: 0.82;
	}

	.person-phone {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
	}

	.company {
		margin-top: 20px;
		padding-top: 12px;
		border-top: 1px solid rgba(255, 255, 255, 0.25);
	}

	.company p {
		margin: 0 0 4px;
		font-size: 13px;
		opacity: 0.82;
	}

	.company h4 {
		margin: 0;
		font-size: 20px;
	}

	.fade-in {
		animation: fadeIn 0.8s ease-in-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 1200px) {
		.module-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.workflow-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	@media (max-width: 992px) {
		.prison-main {
			padding-top: 56px;
		}

		.section-padding {
			padding: 48px 0;
		}

		.hero-grid,
		.contact-grid,
		.two-grid,
		.three-grid {
			grid-template-columns: 1fr;
		}

		.hero-points {
			grid-template-columns: 1fr;
		}
	}

	@media (max-width: 768px) {
		.container-custom {
			padding: 0 14px;
		}

		.section-padding {
			padding: 34px 0;
		}

		.form-grid,
		.module-grid,
		.workflow-grid,
		.principle-grid {
			grid-template-columns: 1fr;
		}

		.hero-section h1 {
			font-size: 32px;
		}

		.hero-section p {
			font-size: 15px;
		}

		.section-head p {
			font-size: 14px;
		}

		.summary-box h2 {
			font-size: 26px;
		}

		.summary-box p {
			font-size: 15px;
		}
	}
</style>